import { withRouter } from 'react-router-dom';
import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadataInternal } from '@jutro/uiconfig';
import { Link } from '@jutro/components';
import _ from 'lodash';
import { FormattedDate, TranslatorContext } from '@jutro/locale';
import messages from './ServiceRequestSummaryTable_AX.messages';
import style from './ServiceRequestSummaryTable_AX.module.scss';
import metadata from './ServiceRequestSummaryTable_AX.metadata.json5';

const dueDateCell = (serviceRequestCell) => {
    const { dueDate } = serviceRequestCell;
    if (dueDate === undefined) {
        return '';
    }

    return <FormattedDate value={new Date(dueDate)} format="short" />;
};

function ServiceRequestSummaryTableAX(props) {
    const {
        dataArray
    } = props;

    const translator = useContext(TranslatorContext);

    const statesForOperation = useMemo(() => {
        return {
            requested: translator(messages.serviceRequestProgressRequested),
            declined: translator(messages.serviceRequestProgressDeclined),
            specialistwaiting: translator(messages.serviceRequestProgressSpecialistWaiting),
            inprogress: translator(messages.serviceRequestProgressInProgress),
            workcomplete: translator(messages.serviceRequestProgressWorkComplete),
            canceled: translator(messages.serviceRequestProgressCanceled),
            draft: translator(messages.serviceRequestProgressDraft),
            expired: translator(messages.serviceRequestProgressExpired),
            ax_pendingarrival: translator(messages.serviceRequestProgressPendingArrival)
        };
    }, [translator]);

    const progressCell = useCallback(({ status }) => {
        return _.get(statesForOperation, status, 'N/A');
    }, [statesForOperation]);

    const serviceRequestNumberCell = useCallback(({ serviceRequestNumber }) => {
        return (
            <div className={style.rowCustom}>
            <Link  to={`/service-request-details/${serviceRequestNumber}`}>
                {serviceRequestNumber}
            </Link>
            </div>
        );
    }, []);

    const tableOverrides = useCallback(() => {
        return {
            dueDateColumn: { renderCell: dueDateCell },
            progressColumn: { renderCell: progressCell },
            serviceRequestNumber: { renderCell: serviceRequestNumberCell },
        };
    }, [serviceRequestNumberCell, progressCell]);

    const overrideProps = {
        summaryTable: {
            data: dataArray
        },
        ...tableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: style,
        resolveCallbackMap: {
        }
    };

    return renderContentFromMetadataInternal(metadata.componentContent, overrideProps, resolvers);
}

ServiceRequestSummaryTableAX.propTypes = {
    dataArray: PropTypes.array,
    isLoading: PropTypes.bool
};

ServiceRequestSummaryTableAX.defaultProps = {
    dataArray: [],
    isLoading: false
};

export default withRouter(ServiceRequestSummaryTableAX);
